"use client";

import { IBlog } from "@/api/AppApi/services/home/interfaces/Blog";
import NextImage from "@/app/components/lib/NextImage";
import { numAsString } from "@/utils/functions/functions";
import SvgAuthor from "../../common/blog-icons/SvgAuthor";
import SvgBlogDate from "../../common/blog-icons/SvgBlogDate";
import SvgComment from "../../common/blog-icons/SvgComment";
import SvgEye from "../../common/blog-icons/SvgEye";
import SvgLike from "../../common/blog-icons/SvgLike";
import SvgMore from "../../common/blog-icons/SvgMore";
import SvgTags from "../../common/blog-icons/SvgTags";
import BlogInfo from "./BlogInfo";
import BlogLinkWrapper from "./BlogLinkWrapper";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useIsRtl from "@/hooks/useIsRtl";

interface Props {
  blog: IBlog;
}
const BlogsPageCardClient: React.FC<Props> = ({ blog }) => {
  const t = useTranslation();
  const isRTL = useIsRtl();
  return (
    <article className="blog-container">
      <BlogLinkWrapper slug={blog.slug ?? blog.id}>
        <div className="img-container">
          <NextImage alt={blog.title} src={blog.image_url} objectFit="cover" />
        </div>
      </BlogLinkWrapper>
      <div className="d-flex justify-content-between flex-nowrap w-100">
        <BlogInfo
          nodes={[
            { svg: <SvgAuthor />, label: blog.author.name },
            { svg: <SvgBlogDate />, label: blog.date },
            {
              svg: <SvgTags />,
              label: blog.tags.map((tag) => tag.value).join(", "),
            },
          ]}
        />
        <div className="info">
          <div className="one-info">{blog?.category?.value}</div>
        </div>
      </div>

      <h3 className="blog-title">
        <BlogLinkWrapper slug={blog.slug ?? blog.id}>
          {blog.title}
        </BlogLinkWrapper>
      </h3>

      <p className="blog-content m-0">{blog.description}</p>
      <div className="reaction-seemore-btn w-100">
        <div className="reaction">
          <BlogInfo
            nodes={[
              { svg: <SvgEye />, label: numAsString(blog.views) },
              { svg: <SvgLike />, label: numAsString(blog.likes) },
              { svg: <SvgComment />, label: numAsString(blog.comments) },
            ]}
          />
        </div>

        <BlogLinkWrapper slug={blog.slug ?? blog.id}>
          <button className="seemore-btn text-nowrap">
            {t.read_more}
            <SvgMore isRTL={isRTL} />
          </button>
        </BlogLinkWrapper>
      </div>
    </article>
  );
};

export default BlogsPageCardClient;
